export default __webpack_public_path__ + "static/media/Edi_Dark2.dd7ee327.svg";